import type { IChecklist } from './checklist'

export enum VERSION_STATUS {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  ERROR = 'error',
  INACTIVE = 'inactive',
  PREPARE = 'prepare',
  PRODUCTION = 'production',
  REMOVED = 'removed_from_store',
  TESTING = 'testing',
  UNKNOWN = 'unknown',
}

export interface IAppVersionAppIcon {
  created_at: string
  download_url: string
  id: string
  original_url: string
  type: string
  updated_at: string
}

interface IAppVersionSDKVersionExternalLinks extends IDBContextExtended {
  sdk_version: string
  sdk_version_id: string
  target: string
  url: string
}

interface IAppVersionSDKVersionsSDK extends IDBContextExtended {
  description: string
  id: string
  key: string
  sdk_versions: string[]
  techno: string
}

interface IAppVersionSDKVersion extends IDBContextExtended {
  application_versions: string[]
  authors: string[]
  changelog: string
  external_links: IAppVersionSDKVersionExternalLinks[]
  id: string
  min_os_version: string
  sdk: IAppVersionSDKVersionsSDK
  sdk_id: string
  status: string
  version: string
}

export interface IAppVersion extends IDBContext {
  app_icon: IAppVersionAppIcon
  application_id: string
  authors: string[] | null
  average_rating: number
  changelog: string
  created_by?: string
  estimated_release_date: string | null
  icon_external_file_id: string
  id: string
  locale_by_id: {
    [key: string]: string
  }
  number_of_ratings: number
  number_of_reviews: number
  price: number | null
  raw_status: string
  release_date: string
  release_version_checklist_id: string
  sdk_versions?: IAppVersionSDKVersion[]
  semantic_version: string
  status: VERSION_STATUS
  updated_by?: string
}

export interface IAppVersionSummary {
  app_icon_url: string
  app_id: string
  authors: string[] | null
  changes?: {
    application_id: string
    created_at: string
    description_changes: number
    display_name_changes: number
    icon_changes: number
    id: string
    keywords_changes: number
    previous_version_id: string
    screenshot_changes: number
    short_description_changes: number
    updated_at: string
    version_id: string
  }
  comments_count: number
  localizations_count: number
  name: string
  owned: boolean
  public_store_id: string
  release_date_ts: number
  semantic_version: string
  status: VERSION_STATUS
  store_url: string
  version_id: string
}

export interface IAppVersionComment extends IDBContextExtended {
  application_version_id: string
  content: string
  id: string
}

export interface IAppVersionLocale extends IDBContext {
  application_version_id: string
  description: string
  display_name: string
  id: string
  keywords: string[] | null
  locale: string
  short_description: string
  whats_new: string
}

export interface IAppVersionWithChecklist extends IAppVersionSummary {
  checklist?: IChecklist
}

interface IAppVersionLocalizationExternalFileInfo {
  created_at: string
  download_url: string
  id: string
  original_url: string
  type: string
  updated_at: string
}

export interface IAppVersionLocalizationExternalFile extends IDBContext {
  application_version_localization_id: string
  device_format: string
  external_file: IAppVersionLocalizationExternalFileInfo
  external_file_id: string
  file_type: string
  position: number
}
